<div class="join-onboarding-root" *transloco="let t">
  <div class="join-content">
    <div class="join-text-area">{{ t('onboarding-participate') }}</div>
    <div class="join-button-area">
      <button
        id="button-join-createaccount"
        join-button
        [routerLink]="'/'+RouterKeys.REGISTER"
      >
        {{ t('onboarding-createaccount') }}
      </button>
      <button
        id="button-join-login"
        join-button
        [routerLink]="'/'+RouterKeys.LOGIN"
      >
      {{ t('login') }}
      </button>
    </div>
  </div>
</div>
